import { render, staticRenderFns } from "./ViewFounders.vue?vue&type=template&id=ad6f16da&scoped=true"
import script from "./ViewFounders.vue?vue&type=script&lang=js"
export * from "./ViewFounders.vue?vue&type=script&lang=js"
import style0 from "./ViewFounders.vue?vue&type=style&index=0&id=ad6f16da&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6f16da",
  null
  
)

export default component.exports